import { render, staticRenderFns } from "./mainTitle.vue?vue&type=template&id=7d95328e&scoped=true&"
import script from "./mainTitle.vue?vue&type=script&lang=js&"
export * from "./mainTitle.vue?vue&type=script&lang=js&"
import style0 from "./mainTitle.vue?vue&type=style&index=0&id=7d95328e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d95328e",
  null
  
)

export default component.exports